export class WorkingNotificationData {
  title: string;
}
